module.exports = __webpack_public_path__ + "img/img16.89cda4b1.png";